import React from 'react';

import {
  ChildrenWrapper,
  HeaderContainer,
  LayoutContainer,
} from '@/shared/components/layouts/auth-layout/auth-layout.styled';
import { TLayoutProps } from '@/shared/components/layouts/auth-layout/auth-layout.types';
import { Head } from '@/shared/components/seo';

export const AuthLayout: React.FC<TLayoutProps> = ({
  children,
  title,
  header,
}) => {
  return (
    <>
      <Head title={title} />
      <HeaderContainer
        direction="column"
        alignItems="flex-end"
        justifyContent="center"
      >
        {header}
      </HeaderContainer>
      <LayoutContainer>
        <ChildrenWrapper>{children}</ChildrenWrapper>
      </LayoutContainer>
    </>
  );
};
